<template>
    <div class="modal-container standard loader" v-if="isLoading">
        <div>
            <div class="header-rainbow"></div>
            <PromptHeader :step="step"></PromptHeader>
            <main>
                <div>
                    <LoaderImg></LoaderImg>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
    import LoaderImg from "./LoaderImg";
    import Prompt from "./Prompt";

    export default {
        name: 'Loader',
        extends: Prompt,
        components: {LoaderImg},
        computed: {
            isLoading: function () {
                if (this.$store.state.loading) {
                    this.show()
                    return true;
                } else {
                    this.hide();
                    return false
                }
            },
            step: function () {
                return this.$store.getters.step();
            }
        }
    }
</script>